import { InteractiveMap } from '@/components/map/InteractiveMap';
import { cityLocationsData } from '@/lib/data';
import { CityLocations } from '@/components/city/CityLocations';
import { MapPin } from '@/lib/types';
import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

export default function CityPage() {
  const [mapPins, setMapPins] = useState<MapPin[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // This is now a client-side fetch.
    fetch('/map-pins.json')
      .then(res => res.json())
      .then(data => {
        setMapPins(data.pins);
        setIsLoading(false);
      })
      .catch(err => {
        console.error("Failed to fetch map pins", err);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="text-center max-w-3xl mx-auto">
        <h1 className="font-headline text-5xl font-bold text-primary">Explora la Ciudad</h1>
        <p className="mt-4 text-lg text-muted-foreground">
          Descubre los lugares más emblemáticos y los secretos mejor guardados de Jartiland. Cada rincón tiene una historia que contar.
        </p>
      </div>
      
      <div className="my-16">
        <h2 className="text-3xl font-bold text-center mb-8 font-headline">Lugares de Interés</h2>
        <CityLocations locations={cityLocationsData} />
      </div>

      <div className="mt-24">
         <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="font-headline text-4xl font-bold text-primary">Mapa del Territorio</h2>
            <p className="mt-4 text-lg text-muted-foreground">
              Sitúa los lugares de interés en el contexto más amplio de nuestras tierras.
            </p>
        </div>
        {isLoading ? (
          <div className="flex justify-center items-center h-96">
            <Loader2 className="h-10 w-10 animate-spin" />
          </div>
        ) : (
          <InteractiveMap locations={mapPins} />
        )}
      </div>
    </div>
  );
}
